import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : process.env.REACT_APP_API_URL;

export const fetchChaptersByBook = createAsyncThunk(
  "chapters/fetchByBook",
  async (bookId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/api/books/${bookId}/`);
      return { bookId, chapters: response.data.chapters };
    } catch (error) {
      return rejectWithValue({ bookId, error: error.message });
    }
  }
);

const chaptersSlice = createSlice({
  name: "chapters",
  initialState: {
    chaptersByBook: {},
    statusByBook: {},
    errorByBook: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChaptersByBook.pending, (state, action) => {
        const bookId = action.meta.arg;
        state.statusByBook[bookId] = "loading";
        state.errorByBook[bookId] = null;
      })
      .addCase(fetchChaptersByBook.fulfilled, (state, action) => {
        const { bookId, chapters } = action.payload;
        state.chaptersByBook[bookId] = chapters;
        state.statusByBook[bookId] = "succeeded";
      })
      .addCase(fetchChaptersByBook.rejected, (state, action) => {
        const { bookId, error } = action.payload;
        state.statusByBook[bookId] = "failed";
        state.errorByBook[bookId] = error;
      });
  },
});

export default chaptersSlice.reducer;
